import React, { type ReactNode } from 'react';
import { classes } from 'src/modules/shared/utils/styles.util';

/** Props for the phone action bar. */
interface MobileActionBarProps {
  /** Actions, usually buttons, laid out side by side. */
  children: ReactNode;
  /** Extra classes for the bar. */
  className?: string;
}

/**
 * Bar fixed to the bottom of the screen for a page's main actions on phones.
 * It hides from the `md` breakpoint, where the page header shows the same
 * actions. Pages using it need bottom padding below `md` (about `pb-28`) so
 * the bar never covers content.
 *
 * @param props - Actions and optional classes.
 * @returns The fixed bottom bar.
 */
export const MobileActionBar: React.FC<MobileActionBarProps> = ({
  children,
  className,
}) => (
  <div
    className={classes(
      'fixed inset-x-0 bottom-0 z-30 flex gap-2 border-t border-neutral-200 bg-white px-4 pb-5 pt-3 md:hidden',
      className
    )}
  >
    {children}
  </div>
);
